import { render, staticRenderFns } from "./flow.vue?vue&type=template&id=a21a4152&scoped=true"
import script from "./flow.vue?vue&type=script&lang=ts"
export * from "./flow.vue?vue&type=script&lang=ts"
import style0 from "./flow.vue?vue&type=style&index=0&id=a21a4152&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21a4152",
  null
  
)

export default component.exports